module.exports = __webpack_public_path__ + "static/media/background-primary.1ca54959.svg";